import { createTheme } from '@mui/material/styles';

const userProfileTheme = createTheme({
  palette: {
    primary: {
      main: '#003f5f',
    },
    secondary: {
      main: '#007698',
    },
    success: {
      main: '#2e7d32',
    },
    warning: {
      main: '#e65100',
    },
    error: {
      main: '#d32f2f',
    },
    info: {
      main: '#0288d1',
    },
    background: {
      default: '#f8f8f8',
      paper: '#ffffff',
    },
    text: {
      primary: '#212121',
      secondary: '#616161',
    },
  },
  typography: {
    fontFamily: '"Geist", "PT Sans", sans-serif',
    h4: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
    subtitle1: {
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
        fullWidth: true,
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#f5f5f5',
          '&.Mui-disabled': {
            backgroundColor: '#eeeeee',
          },
        },
      },
    },
  },
});

export default userProfileTheme;
